import { useState, useEffect } from 'react';
import { Card, Tooltip, Tag, Modal } from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import utils from '../../Common/utils';
import { Pagination, Table, Button, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {EditFilled, CopyOutlined, DeleteOutlined} from '@ant-design/icons';
import { useSelector, useDispatch } from "react-redux";
import { setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import { loadProjects as reloadProjectsGlobal } from '../../slices/thunk';
import { Link } from 'react-router-dom';


const api = new APIClient();


const ProjectsList = () => {
  document.title = "Projekti" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);


  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Search + the project-only year filter. Date range is hidden because the
      // projects endpoint has no date filtering (it confused the year picker).
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      shown: ['project_year'],
      disabled: []
    }))
  }, []);


  const loadProjects = () => {
    setLoading(true);
    api.get('/api/projects/', filterdata)
      .then((resp) => setData(resp))
      .finally(() => setLoading(false));
  }

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }


  const onDuplicate = (r) => {
    Modal.confirm({
      title: 'Podvojitev projekta',
      content: `Projekt "${r.title}" bo podvojen skupaj s podatki in proračunom. Transakcije in nalogi ne bodo preneseni.`,
      okText: 'Podvoji',
      cancelText: 'Prekliči',
      onOk: () => api.post(`/api/projects/${r.id}/duplicate/`).then(() => loadProjects()),
    });
  }

  const onBulkDelete = () => {
    Modal.confirm({
      title: 'Brisanje projektov',
      content: `Izbrisano bo ${selectedIds.length} projektov. Vsi podatki projektov, vključno s transakcijami in nalogi, bodo trajno izbrisani.`,
      okText: 'Izbriši',
      cancelText: 'Prekliči',
      okButtonProps: { danger: true },
      onOk: () => api.delete('/api/projects/delete_bulk/', { ids: selectedIds }, { successMsg: `Izbrisanih ${selectedIds.length} projektov` })
        .then(() => {
          setSelectedIds([]);
          loadProjects();
          dispatch(reloadProjectsGlobal());
        }),
    });
  }

  const columns = [
    {title: 'Naziv', dataIndex: 'title', render: (x, proj) => <Link to={{pathname: `/project/${proj.id}`}}>{proj.title}</Link>},
    {title: 'Leto', dataIndex: 'year'},
    {title: 'Tip', dataIndex: 'type_title', render: type_title => <Tag>{type_title}</Tag>},
    {title: 'Uredi', key: 'edit', render: r => <Link to={`/project/${r.id}`}><Button size='small' onClick={ev => onEdit(r.id)}><EditFilled/></Button></Link>},
    {title: 'Podvoji', key: 'duplicate', render: r => <Button size='small' onClick={() => onDuplicate(r)}><CopyOutlined /></Button>},
  ]


  useEffect(() => {
    loadProjects()
  }, [filterdata]);


  return (
    <>
      <Breadcrumb parentTitle="Projekti" pageTitle="Projekti" />

      <Card
        title='Projekti'
        extra={
          <Space>
            <Tooltip title={'Izberite projekte za brisanje!'}>
              <Button
                danger
                disabled={selectedIds.length == 0}
                onClick={onBulkDelete}
                icon={<DeleteOutlined />}
              />
            </Tooltip>
            <Link to="/project/">
              <Button icon={<PlusOutlined />} />
            </Link>
        </Space>
        }
      >
        <Table
            size="small"
            loading={loading}
            columns={columns}
            dataSource={data?.results || []}
            pagination={false}
            rowKey={obj => obj.id}
            rowSelection={{
            onChange: (selectedIds) => setSelectedIds(selectedIds)}}
            rowClassName={(record) => {}}
        />
        <Pagination
            current={filterdata.page}
            onChange={pInx => dispatch(updateFilterData({page: pInx}))}
            showSizeChanger={false}
            {...utils.processPagination(data?.pagination)}
        />
      </Card>
    </>
  )
}

export default ProjectsList;
